var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(_vm.style),attrs:{"alt":"Sxtanna Logo","src":require("../assets/sxtanna.svg")}})}
var staticRenderFns = []

export { render, staticRenderFns }